import type { IconSets } from "@toruslabs/vue-components";

export default {
  ArrowRightIcon: () => import("@toruslabs/vue-icons/arrows/ArrowRightIcon"),
  AdjustmentsIcon: () => import("@toruslabs/vue-icons/others/AdjustmentsIcon"),
  MobileIcon: () => import("@toruslabs/vue-icons/gadgets/MobileIcon"),
  DesktopIcon: () => import("@toruslabs/vue-icons/gadgets/DesktopIcon"),
  CheckCircleSolidIcon: () => import("@toruslabs/vue-icons/notifications/CheckCircleSolidIcon"),
  EyeOffSolidIcon: () => import("@toruslabs/vue-icons/security/EyeOffSolidIcon"),
  EyeSolidIcon: () => import("@toruslabs/vue-icons/security/EyeSolidIcon"),
  InformationCircleSolidIcon: () => import("@toruslabs/vue-icons/security/InformationCircleSolidIcon"),
  LockClosedIcon: () => import("@toruslabs/vue-icons/security/LockClosedIcon"),
  TrashIcon: () => import("@toruslabs/vue-icons/others/TrashIcon"),
  TrashSolidIcon: () => import("@toruslabs/vue-icons/others/TrashSolidIcon"),
  ExclamationCircleSolidIcon: () => import("@toruslabs/vue-icons/notifications/ExclamationCircleSolidIcon"),
  XIcon: () => import("@toruslabs/vue-icons/notifications/XIcon"),
  XSolidIcon: () => import("@toruslabs/vue-icons/notifications/XSolidIcon"),
  UploadIcon: () => import("@toruslabs/vue-icons/mail/UploadIcon"),
  ColorSwatchIcon: () => import("@toruslabs/vue-icons/file/ColorSwatchIcon"),
  DocumentDuplicateIcon: () => import("@toruslabs/vue-icons/file/DocumentDuplicateIcon"),
  PhoneIcon: () => import("@toruslabs/vue-icons/call/PhoneIcon"),
  ArrowCircleLeftIcon: () => import("@toruslabs/vue-icons/arrows/ArrowCircleLeftIcon"),
  ChevronDownSolidIcon: () => import("@toruslabs/vue-icons/arrows/ChevronDownSolidIcon"),
  ChevronUpSolidIcon: () => import("@toruslabs/vue-icons/arrows/ChevronUpSolidIcon"),
  CloudIcon: () => import("@toruslabs/vue-icons/software/CloudIcon"),
  DownloadIcon: () => import("@toruslabs/vue-icons/software/DownloadIcon"),
  UserCircleIcon: () => import("@toruslabs/vue-icons/users/UserCircleIcon"),
  MailIcon: () => import("@toruslabs/vue-icons/mail/MailIcon"),
  InformationCircleIcon: () => import("@toruslabs/vue-icons/security/InformationCircleIcon"),
  XCircleSolidIcon: () => import("@toruslabs/vue-icons/notifications/XCircleSolidIcon"),
  IdentificationIcon: () => import("@toruslabs/vue-icons/security/IdentificationIcon"),
  KeySolidIcon: () => import("@toruslabs/vue-icons/security/KeySolidIcon"),
} as unknown as IconSets;